import { CompanyDto } from "~~/types/company";

export interface SavedCompaniesResponse {
	data: CompanyDto[];
	current_page: number;
	last_page: number;
}

export class SavedCompaniesRepository {
	private baseUrl = globalConfig.API + "/profile/saved-companies";
	private lovedCompanyIdsUrl = globalConfig.API + "/profile/loved-company-ids";

	async getSavedCompanies(page = 1, perPage = 15): Promise<SavedCompaniesResponse> {
		const token = useAuth.getToken();
		const url = new URL(this.baseUrl);
		url.searchParams.append("page", String(page));
		url.searchParams.append("per_page", String(perPage));

		try {
			return await $fetch<SavedCompaniesResponse>(url.href, {
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});
		} catch (err) {
			showError({ statusCode: 500, message: "SavedCompaniesRepository.getSavedCompanies error" });
			throw err;
		}
	}

	async getLovedCompanyIds(): Promise<number[]> {
		const token = useAuth.getToken();

		try {
			return await $fetch<number[]>(this.lovedCompanyIdsUrl, {
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});
		} catch (err) {
			console.error("SavedCompaniesRepository.getLovedCompanyIds error");
			return [];
		}
	}
}
